export default "__VITE_ASSET__131fDIBc__"